module.exports = __webpack_public_path__ + "img/1.7.5-6.5b8f03af.jpg";